export const iconFontAwesomeMapsPerson = (
	<i className="fa-solid fa-person"></i>
);
